module.exports = __webpack_public_path__ + "static/media/AthanasiosMandratzis.4c92f6fa.jpg";